import { Print } from "@mui/icons-material";
import { useFormik } from "formik";
import JoditEditor from "jodit-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Form, Modal, Tab, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import ReactToPrint from "react-to-print";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { assets } from "../../assets";
import BanglaCalender from "../../pages/frontend/userPanel/form_two/BanglaCalender";
import { useLazyGetByRoleQuery } from "../../redux/api/applicationCopyrightApiSlice";
import { useGetRoleInQuery } from "../../redux/api/categoryApiSlice";
import { useUnauthorizedApprovalMutation } from "../../redux/api/submittedCopyrightAgreementApiSlice";
import { accessRoles } from "../../utils/accessRoles";
import { useAuth } from "../../utils/authorization";
import { config } from "../../utils/config";
import {
  globalDateFormat,
  localDateFormat,
  localDateFormatName,
  localDateFormatNameBN,
  localTimeFormat,
} from "../../utils/dateFormat";
import { transformErrorsToObjectStructure } from "../../utils/transformErrorsToObjectStructure";
import OfficeAddress from "../OfficeAddress";
import HCLetterTransfer from "./HCLetterTransfer";
import NothiTransfer from "./NothiTransfer";

const UnauthorizedContent = ({ info }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [isObservation, setIsObservation] = useState(false);
  const { authUser } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();
  const [content, setContent] = useState("");
  const [errors, setErrors] = useState(false);
  const editor = useRef(null);
  const printLetter = useRef();
  const [
    Verify,
    {
      isLoading: isLoadingVerify,
      isSuccess: isSuccessSubmit,
      error: errorSubmit,
      isError: isErrorSubmit,
      data: dataSubmit,
    },
  ] = useUnauthorizedApprovalMutation();

  const roleMapping = `[${accessRoles.DeputyRegister}, ${accessRoles.Register}]`;

  const { data: roles, isFetching } = useGetRoleInQuery(roleMapping);
  const rolesOption =
    roles?.data?.map((data) => ({
      value: data.id,
      label: data.bn_name,
    })) || [];

  const [findUser, { data: users }] = useLazyGetByRoleQuery();

  const usersOption =
    (users?.data &&
      Object.entries(users.data)
        .filter(([key]) => authUser.id !== Number(key))
        .map(([key, value]) => ({
          value: Number(key),
          label: value,
        }))) ||
    [];

  const pageTitle =
    info.fileStatus === 6
      ? "অননুমোদনের চিঠি প্রস্তুত"
      : info.fileStatus === 29
      ? "অননুমোদনের চিঠি অনুমোদন "
      : "অননুমোদনের চিঠি প্রেরণ";

  const pageAleart =
    info.fileStatus === 6
      ? "আপনি কি চিঠি অনুমোদনের জন্য পাঠাতে চান?"
      : info.fileStatus === 29
      ? "আপনি কি চিঠি অনুমোদন দিতে চান?"
      : "আপনি কি চিঠি প্রেরণ করতে চান?";

  const validationSchema = Yup.object().shape({
    record_no: Yup.string().required("রেকর্ড নাম্বার প্রযোজ্য।"),
    record_date: Yup.date().required("রেকর্ড তারিখ প্রযোজ্য।"),
    subject: Yup.string().required("বিষয় প্রযোজ্য।"),
    role_id: Yup.number().required("পদবী প্রযোজ্য।"),
    user_id: Yup.number().required("প্রাপক প্রযোজ্য।"),
    comments: Yup.string().when("submit", {
      is: (val) => info.fileStatus === 30 || [2, 41, 42].includes(val),
      then: () => Yup.string().required("আপনার মন্তব্য লিখুন।"),
      otherwise: () => Yup.string().nullable(),
    }),
  });

  const formik = useFormik({
    initialValues: {
      record_no: "",
      record_date: globalDateFormat(new Date()),
      subject: "",
      detail: "",
      role_id: "",
      user_id: "",
      comments: "",
    },
    validationSchema,
    onSubmit: (values) => {
      if (content.length < 30) {
        return setErrors("কমপক্ষে ২০ টা অক্ষর লিখতে হবে ।");
      }
      setErrors("");
      const formData = { ...values, detail: content };
      Swal.fire({
        text:
          formik.values?.submit === 41
            ? "আপনি কি চিঠি পর্যবেক্ষণ দিতে চান?"
            : pageAleart,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "না",
        confirmButtonText: "হ্যাঁ",
      }).then((result) => {
        if (result.isConfirmed) {
          Verify({ id, formData, fileStatus: info.fileStatus });
        }
      });
    },
  });
  useEffect(() => {
    if (isSuccessSubmit) {
      toast.success(dataSubmit?.message);
      formik.resetForm();
      navigate(-1);
    }
    if (isErrorSubmit) {
      toast.error(errorSubmit?.data?.message);
      formik.setErrors(
        transformErrorsToObjectStructure(errorSubmit.data?.data || {})
      );
    }
    // eslint-disable-next-line
  }, [isErrorSubmit, isSuccessSubmit]);

  useEffect(() => {
    if (info?.unauthorized?.detail) {
      if (info?.unauthorized?.user?.role?.id) {
        findUser(info?.unauthorized?.user?.role?.id);
      }
      const sub = `${info.workTitle} নামক ${info.category} কর্মের কপিরাইট রেজিস্ট্রেশন সংশোধন ।`;
      formik.setValues((prev) => ({
        ...prev,
        record_no: info?.unauthorized?.record_no,
        record_date:
          info?.unauthorized?.record_date ?? globalDateFormat(new Date()),
        subject: info?.unauthorized?.subject ?? sub,
        role_id: info?.unauthorized?.user?.role?.id ?? "",
        user_id: info?.unauthorized?.user?.id ?? "",
      }));
      setContent(info?.unauthorized?.detail);
    } else {
      if (info?.unauthorized?.user?.role?.id) {
        findUser(info?.unauthorized?.user?.role?.id);
      }
      const sub =
        info.fileStatus === 6
          ? `${info.workTitle} নামক ${info.category} কর্মের কপিরাইট রেজিস্ট্রেশন সংশোধন ।`
          : "";
      formik.setValues((prev) => ({
        ...prev,
        subject: info?.unauthorized?.subject ?? sub,
        role_id: info?.unauthorized?.user?.role?.id ?? "",
        user_id: info?.unauthorized?.user?.id ?? "",
      }));
      setIsEdit(true);
    }
  }, [info?.unauthorized]);

  const handleModalClose = () => {
    if (info?.unauthorized?.detail) {
      formik.setValues((prev) => ({
        ...prev,
        role_id: info?.unauthorized?.user?.role?.id ?? "",
        user_id: info?.unauthorized?.user?.id ?? "",
      }));
    }
    setIsObservation(false);
  };

  const handleModalOpen = () => {
    if (info?.unauthorized?.subject) {
      formik.setValues((prev) => ({
        ...prev,
        role_id: "",
        user_id: "",
      }));
    }
    setIsObservation(true);
  };

  const defaultValue = {
    value: "",
    label: "নির্বাচন করুন",
  };

  const user = info?.unauthorized?.user;

  const handleEditorChange = useCallback((newContent) => {
    setContent(newContent);
  }, []);

  const [valueTab, setValueTab] = useState("one");

  const handleTabChange = (key) => {
    setValueTab(key);
  };

  const fromAdmin = [2, 4].includes(info?.unauthorized?.user?.role?.id);

  const pageSubTitle =
    info.fileStatus === 6
      ? "চিঠি প্রস্তুত"
      : info.fileStatus === 29
      ? "চিঠি অনুমোদন "
      : "চিঠি";

  return (
    <>
      <div className="d-flex justify-content-between align-items-center bg-slate p-2 mb-3">
        <div className="fw-semibold">{pageTitle}</div>
        <ReactToPrint
          trigger={() => <Print className="fs-4 text-primary cursor-pointer" />}
          content={() => printLetter.current}
        />
      </div>
      <Tabs
        activeKey={valueTab}
        onSelect={handleTabChange}
        aria-label="secondary tabs example"
      >
        <Tab eventKey="one" title={pageSubTitle}>
          {info.fileStatus === 6 && info?.unauthorized?.user && (
            <div className="card p-2 mt-2">
              <div>
                <label htmlFor="">
                  অননুমোদন {fromAdmin ? "আদেশ" : "পুনর্বিবেচনা"}
                </label>
                <p>{info?.unauthorized?.comment}</p>
              </div>
              <div className="d-flex justify-content-end">
                <div className="text-center">
                  <div className="fw-semibold">
                    {fromAdmin ? "আদেশক্রমে" : "হইতে"}
                  </div>
                  <p className="m-0">{info?.unauthorized?.user?.name}</p>
                  <p className="m-0">
                    {info?.unauthorized?.user?.role?.bnName}
                  </p>
                  <div>তারিখ : {localDateFormat(info?.unauthorized?.date)}</div>
                  <div>সময় : {localTimeFormat(info?.unauthorized?.date)}</div>
                </div>
              </div>
            </div>
          )}
          {info.fileStatus === 29 && (
            <div className="card p-2 mt-2">
              <span className="fw-semibold">হইতে, </span>{" "}
              {info?.unauthorized?.sendBy.name} (
              {info?.unauthorized?.sendBy?.role?.bnName})
            </div>
          )}

          <form onSubmit={formik.handleSubmit}>
            <div className="py-2" ref={printLetter}>
              <div className="card p-3">
                <div ref={printLetter}>
                  <div className="text-center">
                    <img
                      className="my-3"
                      src={assets.logoBlack}
                      style={{ width: "350px" }}
                      alt=""
                    />
                    <OfficeAddress />

                    <p className="m-0">
                      <Link target="_blank" to={"//www.copyrightoffice.gov.bd"}>
                        www.copyrightoffice.gov.bd
                      </Link>
                    </p>
                  </div>
                  <div
                    className={`d-flex justify-content-between py-3 mt-2 align-items-center`}
                  >
                    <div className={`d-flex gap-2`}>
                      {!isEdit ? (
                        <> {formik.values.record_no}</>
                      ) : (
                        <span>
                          {" "}
                          <Form.Control
                            placeholder="নথি / স্বারক / রেজিঃ নং "
                            value={formik.values.record_no}
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            errors={formik.errors}
                            touched={formik.touched}
                            name="record_no"
                          />
                          {formik.errors.record_no &&
                            formik.touched.record_no && (
                              <span className="text-danger">
                                {formik.errors.record_no}
                              </span>
                            )}
                        </span>
                      )}
                    </div>
                    <div
                      className={`d-flex gap-3 ${
                        !isEdit && "align-items-center "
                      }`}
                    >
                      <div
                        className={`d-flex gap-3 ${
                          isEdit && "mt-4"
                        } fw-semibold`}
                      >
                        তারিখঃ
                      </div>
                      <div>
                        {!isEdit ? (
                          <>
                            {localDateFormatNameBN(formik.values.record_date)}
                            <hr className="m-0" />
                            {localDateFormatName(formik.values.record_date)}
                          </>
                        ) : (
                          <>
                            {localDateFormatNameBN(formik.values.record_date)}
                            <BanglaCalender
                              placeholder={"তারিখ"}
                              value={formik.values.record_date}
                              onChange={(val) => {
                                formik.setFieldValue(
                                  "record_date",
                                  globalDateFormat(val)
                                );
                              }}
                            />
                            {formik.errors?.record_date ? (
                              <span className="text-danger">
                                {formik.errors.record_date}
                              </span>
                            ) : (
                              <div style={{ height: "24px" }}></div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div>
                    <p className={`fw-semibold mt-4 w-100 d-flex gap-2`}>
                      <span className={`${isEdit && "mt-2"} `}>বিষয়ঃ </span>
                      {!isEdit ? (
                        <> {formik.values.subject}</>
                      ) : (
                        <div className="w-100">
                          {" "}
                          <Form.Control
                            value={formik.values.subject}
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            errors={formik.errors}
                            touched={formik.touched}
                            name="subject"
                          />
                          {formik.errors.subject && formik.touched.subject && (
                            <span className="text-danger">
                              {formik.errors.subject}
                            </span>
                          )}
                        </div>
                      )}
                    </p>
                  </div>
                  <p className="pb-4">
                    {!isEdit ? (
                      <p
                        className="m-0"
                        dangerouslySetInnerHTML={{ __html: content }}
                      ></p>
                    ) : (
                      <>
                        <JoditEditor
                          ref={editor}
                          value={content}
                          config={config}
                          tabIndex={1}
                          onBlur={handleEditorChange}
                        />
                        {errors ? (
                          <span className="text-danger">{errors}</span>
                        ) : (
                          <div style={{ height: "24px" }}></div>
                        )}
                      </>
                    )}
                  </p>
                  <div className="d-flex justify-content-between my-2">
                    <div>
                      <div className="mt-3">
                        {info.name && (
                          <>
                            <p className="m-0">{info?.name}</p>
                            <p className="m-0">{info?.email}</p>
                            <p className="m-0">{info?.address}</p>
                          </>
                        )}
                      </div>
                    </div>
                    <div>
                      <div className="mt-3 text-end">
                        {info.fileStatus !== 6 && (
                          <>
                            {user?.sign && (
                              <>
                                <img
                                  style={{ height: "40px" }}
                                  src={user?.sign}
                                  alt=""
                                />
                              </>
                            )}
                            <p className="m-0">{user?.name}</p>
                            <p className="m-0">{user?.role?.bnName}</p>
                            <p className="m-0">{user?.email}</p>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {[6].includes(info.fileStatus) && (
              <div className="row">
                <div className="col-md-6">
                  <label className="my-2 fw-semibold" htmlFor="role_id">
                    পদবী
                  </label>
                  <Select
                    name="role_id"
                    options={rolesOption}
                    value={
                      formik.values.role_id
                        ? rolesOption.find(
                            (option) => option.value === formik.values.role_id
                          )
                        : defaultValue
                    }
                    onChange={(selectedOption) => {
                      findUser(selectedOption.value);
                      formik.setValues((prev) => {
                        return {
                          ...prev,
                          user_id: "",
                        };
                      });
                      formik.setFieldValue("role_id", selectedOption.value);
                    }}
                    onBlur={formik.handleBlur}
                    classNamePrefix="react-select"
                  />
                  {formik.touched.role_id && formik.errors.role_id ? (
                    <div className="text-danger">{formik.errors.role_id}</div>
                  ) : null}
                </div>
                <div className="col-md-6">
                  <label className="my-2 fw-semibold" htmlFor="user_id">
                    প্রাপক
                  </label>
                  <Select
                    name="user_id"
                    options={usersOption}
                    value={
                      formik.values.user_id
                        ? usersOption.find(
                            (option) => option.value === formik.values.user_id
                          )
                        : defaultValue
                    }
                    onChange={(selectedOption) =>
                      formik.setFieldValue("user_id", selectedOption.value)
                    }
                    onBlur={formik.handleBlur}
                    classNamePrefix="react-select"
                  />
                  {formik.touched.user_id && formik.errors.user_id ? (
                    <div className="text-danger">{formik.errors.user_id}</div>
                  ) : null}
                </div>
              </div>
            )}
            {/* {[29, 30, 36].includes(info.fileStatus) && ( */}
            <>
              <label className="my-2 fw-semibold" htmlFor="comments">
                মন্তব্য
              </label>
              <Form.Control
                name="comments"
                placeholder="এখানে লিখুন"
                aria-label="Username"
                aria-describedby="basic-addon1"
                as={"textarea"}
                rows={6}
                value={formik.values.comments}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.comments && formik.errors.comments}
              />
              {formik.touched.comments && formik.errors.comments ? (
                <div className="text-danger">{formik.errors.comments}</div>
              ) : null}
            </>
            {/* )} */}
            <div className="my-4 text-center d-flex justify-content-center flex-wrap gap-3">
              {[6, 29].includes(info.fileStatus) && info.fileStatus !== 36 && (
                <>
                  <div className="mr-3">
                    <Button
                      onClick={() => setIsEdit(!isEdit)}
                      disabled={isLoadingVerify}
                    >
                      {isEdit ? "প্রিভিউ" : "সম্পাদনা করুন"}
                    </Button>
                  </div>
                </>
              )}
              {[29, 36].includes(info.fileStatus) && (
                <Button
                  variant="danger"
                  type={info.fileStatus !== 36 ? "" : "submit"}
                  disabled={isLoadingVerify}
                  className="me-3"
                  onClick={() => {
                    if (info.fileStatus !== 36) {
                      handleModalOpen();
                    } else {
                      formik.setFieldValue("submit", 42);
                    }
                  }}
                >
                  চিঠি পর্যবেক্ষণ
                </Button>
              )}
              <div className="mr-3">
                {[29].includes(info.fileStatus) && info.fileStatus !== 36 ? (
                  <>
                    <Button
                      variant="success"
                      type="submit"
                      disabled={isLoadingVerify}
                      className="me-3"
                      onClick={() => {
                        formik.setFieldValue("submit", 1);
                      }}
                    >
                      অনুমোদন
                    </Button>
                    <Button
                      variant="secondary"
                      type="submit"
                      disabled={isLoadingVerify}
                      onClick={() => {
                        formik.setFieldValue("submit", 2);
                      }}
                    >
                      সংশোধন
                    </Button>
                  </>
                ) : (
                  <>
                    {info.fileStatus !== 36 && (
                      <Button
                        variant="success"
                        type="submit"
                        disabled={isLoadingVerify}
                      >
                        {info.fileStatus === 30 ? "চিঠি পাঠান" : "দাখিল করুন"}
                      </Button>
                    )}
                  </>
                )}
              </div>
            </div>
          </form>
        </Tab>

        {info.fileStatus !== 36 && (
          <Tab eventKey="two" title={"নথি স্থানান্তর"}>
            <NothiTransfer info={info} />
          </Tab>
        )}
        {info.fileStatus === 6 && (
          <Tab eventKey="three" title={"চিঠি স্থানান্তর"}>
            <HCLetterTransfer info={info} />
          </Tab>
        )}
      </Tabs>
      <Modal show={isObservation} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title className="fs-6">
            পদবী এবং ব্যবহারকারী নির্বাচন করুন
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6">
              <label className="my-2 fw-semibold" htmlFor="role_id">
                পদবী
              </label>
              <Select
                name="role_id"
                options={rolesOption}
                value={
                  formik.values.role_id
                    ? rolesOption.find(
                        (option) => option.value === formik.values.role_id
                      )
                    : defaultValue
                }
                onChange={(selectedOption) => {
                  findUser(selectedOption.value);
                  formik.setValues((prev) => {
                    return {
                      ...prev,
                      user_id: "",
                    };
                  });
                  formik.setFieldValue("role_id", selectedOption.value);
                }}
                onBlur={formik.handleBlur}
                classNamePrefix="react-select"
                isDisabled={isFetching}
                isLoading={isFetching}
              />
              {formik.touched.role_id && formik.errors.role_id ? (
                <div className="text-danger">{formik.errors.role_id}</div>
              ) : null}
            </div>
            <div className="col-md-6">
              <label className="my-2 fw-semibold" htmlFor="user_id">
                প্রাপক
              </label>
              <Select
                required={true}
                name="user_id"
                options={usersOption}
                value={
                  formik.values.user_id
                    ? usersOption.find(
                        (option) => option.value === formik.values.user_id
                      )
                    : defaultValue
                }
                onChange={(selectedOption) =>
                  formik.setFieldValue("user_id", selectedOption.value)
                }
                onBlur={formik.handleBlur}
                classNamePrefix="react-select"
              />
              {formik.touched.user_id && formik.errors.user_id ? (
                <div className="text-danger">{formik.errors.user_id}</div>
              ) : null}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            বন্ধ
          </Button>
          <Button
            variant="primary"
            onClick={(e) => {
              formik.setFieldValue("submit", 41);
              formik.handleSubmit(e);
            }}
          >
            দাখিল
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UnauthorizedContent;
